import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
// Routes
import { ROUTES } from './constants/routes';
// Layouts
import { AdminLayout } from './components/layout/AdminLayout';
import { RegulatorLayout } from './components/layout/RegulatorLayout';
// Auth Pages
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
// Customer Pages
import { LandingPage } from './pages/LandingPage';
import { RefundFlow } from './pages/RefundFlow';
import { WalletPage } from './pages/WalletPage';
import { SearchPage } from './pages/SearchPage';
import { HistoryPage } from './pages/HistoryPage';
// Admin Pages
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { RefundManagement } from './pages/admin/RefundManagement';
import { InvoiceManagement } from './pages/admin/InvoiceManagement';
import { ReconciliationPage } from './pages/admin/ReconciliationPage';
import { FraudDetection } from './pages/admin/FraudDetection';
// Regulator Pages
import { AuditTrail } from './pages/regulator/AuditTrail';
import { ComplianceMonitor } from './pages/regulator/ComplianceMonitor';
export function App() {
  return <BrowserRouter data-id="element-0">
      {/* Toast Notifications */}
      <Toaster position="top-right" toastOptions={{
      style: {
        background: '#fff',
        border: '1px solid #E0E0E0',
        borderRadius: '12px',
        padding: '16px',
        fontFamily: 'Montserrat, system-ui, sans-serif'
      }
    }} data-id="element-1" />

      <Routes data-id="element-2">
        {/* Auth Routes */}
        <Route path={ROUTES.LOGIN} element={<LoginPage data-id="element-4" />} data-id="element-3" />
        <Route path={ROUTES.SIGNUP} element={<SignupPage data-id="element-6" />} data-id="element-5" />
        <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLoginPage data-id="element-8" />} data-id="element-7" />

        {/* Customer Routes */}
        <Route path={ROUTES.HOME} element={<LandingPage data-id="element-10" />} data-id="element-9" />
        <Route path={ROUTES.REFUND} element={<RefundFlow data-id="element-12" />} data-id="element-11" />
        <Route path={ROUTES.WALLET} element={<WalletPage data-id="element-14" />} data-id="element-13" />
        <Route path={ROUTES.SEARCH} element={<SearchPage data-id="element-16" />} data-id="element-15" />
        <Route path={ROUTES.HISTORY} element={<HistoryPage data-id="element-18" />} data-id="element-17" />

        {/* Admin Routes */}
        <Route path={ROUTES.ADMIN} element={<AdminLayout data-id="element-20" />} data-id="element-19">
          <Route index element={<AdminDashboard data-id="element-22" />} data-id="element-21" />
          <Route path="refunds" element={<RefundManagement data-id="element-24" />} data-id="element-23" />
          <Route path="invoices" element={<InvoiceManagement data-id="element-26" />} data-id="element-25" />
          <Route path="reconciliation" element={<ReconciliationPage data-id="element-28" />} data-id="element-27" />
          <Route path="fraud" element={<FraudDetection data-id="element-30" />} data-id="element-29" />
        </Route>

        {/* Regulator Routes */}
        <Route path={ROUTES.REGULATOR} element={<RegulatorLayout data-id="element-32" />} data-id="element-31">
          <Route index element={<AuditTrail data-id="element-34" />} data-id="element-33" />
          <Route path="compliance" element={<ComplianceMonitor data-id="element-36" />} data-id="element-35" />
        </Route>
      </Routes>
    </BrowserRouter>;
}